export function onReadyLzuiFeature() {
  import(/* webpackChunkName: "lzui-feature" */ 'vue_features/lzui/lzui_feature').then(({ default: LzuiFeature }) => {
    const el = document.getElementById('lzui-vue')
    LzuiFeature({ el, locale: 'en' })
  })
}
